import { colorBlack } from './color';
import { CSSProperties } from 'typestyle/lib/types';

export const shadowNotification = `0 1px 2px 0 rgba(0, 0, 0, 0.17)`;
export const shadowSubtle = `0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)`;
export const shadowFirm = `0 0 6px ${colorBlack.toRGBA()}`;

export const shadowElevation1: CSSProperties = {
  boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.3)',
};

export const shadowElevation2: CSSProperties = {
  boxShadow: '0px 4px 6px 1px rgba(0,0,0,0.2)',
};

export const shadowElevation3: CSSProperties = {
  boxShadow: '0px 6px 6px 1px rgba(0,0,0,0.05)',
};

export const shadowElevation4: CSSProperties = {
  boxShadow: '-6px 0px 6px 1px rgba(0,0,0,0.05)',
};
